import React, { useEffect, useState } from "react";
import { ErrorBox, OrgModal, PrimaryButton, TextButton } from "./OrgModal";
import RoleOptions from "./RoleOptions";
import { orgErrorMessage } from "../../utils/organisationApi";

// Used to change a member's role and to approve a join request with a role
const RolePickerModal = ({ isOpen, onClose, title, intro, roles, initialRole, submitLabel, busyLabel, onSubmit }) => {
  const [role, setRole] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setRole(roles.includes(initialRole) ? initialRole : roles.includes("panelist") ? "panelist" : roles[0] || "");
    setError("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, initialRole]);

  const handleSubmit = async () => {
    if (!role) {
      setError("Choose a role.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onSubmit(role);
      onClose();
    } catch (err) {
      setError(orgErrorMessage(err, "Something went wrong. Try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <OrgModal
      isOpen={isOpen}
      onClose={saving ? () => {} : onClose}
      titleId="role-picker-title"
      title={title}
      footer={
        <>
          <TextButton onClick={onClose} disabled={saving}>
            Cancel
          </TextButton>
          <PrimaryButton onClick={handleSubmit} disabled={saving || (initialRole && role === initialRole)}>
            {saving ? busyLabel : submitLabel}
          </PrimaryButton>
        </>
      }
    >
      {intro && <div className="text-sm">{intro}</div>}
      <RoleOptions name="role-picker" roles={roles} value={role} onChange={setRole} />
      <ErrorBox>{error}</ErrorBox>
    </OrgModal>
  );
};

export default RolePickerModal;
